import { useSearchParams } from 'react-router-dom';
import { forwardRef, useState, useEffect } from 'react';
import RecorderFactory from './recorders/RecorderFactory';
import { apiClient } from '../../services/apiClient';
import { useAuth } from '../../auth/AuthContext';

const AudioRecorder = forwardRef((props, ref) => {
  const [searchParams] = useSearchParams();
  const { user } = useAuth();
  const [defaultRecorder, setDefaultRecorder] = useState('azure');

  const transcriptionMode = user?.preferences?.transcription_mode || 'streaming';

  useEffect(() => {
    if (transcriptionMode === 'file') return;

    const fetchDefaultRecorder = async () => {
      try {
        const response = await apiClient.get('/api/settings/stt-engine');
        setDefaultRecorder(response.value);
      } catch (error) {
        console.error('Error fetching STT engine setting:', error);
        setDefaultRecorder('azure');
      }
    };

    fetchDefaultRecorder();
  }, [transcriptionMode]);

  // File mode wins over URL/STT engine; URL ?recorder= still overrides streaming engines
  let recorderType;
  if (transcriptionMode === 'file') {
    recorderType = 'file';
  } else {
    recorderType = searchParams.get('recorder') || defaultRecorder;
  }

  return RecorderFactory.create(recorderType, { ...props, ref });
});

export default AudioRecorder;
